/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { CONTACT_TYPE_CUSTOMER } from '@gh/builder-shared-data';
import { createContextRoute } from '@gh/common-internal-shared';
import {
  ContactDetailsBusinessService,
  ContactDetailsCustomerAdditionalDetailsTabComponent,
  ContactDetailsCustomerCommonTabComponent,
  ContactDetailsSharedCommunicationListTabComponent,
  ContactDetailsSharedCustomFieldsTabComponent,
  ContactDetailsSharedPortalTabComponent,
  ContactDetailsSharedTermsPayerTabComponent,
} from '../../index';
import { ContactDetailsModel } from '../../services/contact-details-model.service';
import { ContactDetailsCustomerFormState } from './contact-details-customer-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-details-customer-tab',
  templateUrl: 'contact-details-customer-tab.component.html',
})
export class ContactDetailsCustomerTabComponent {
  routes = [
    createContextRoute({
      component: ContactDetailsCustomerCommonTabComponent,
      path: 'common',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initCustomerCommonTabView',
      },
    }),

    createContextRoute({
      component: ContactDetailsSharedTermsPayerTabComponent,
      path: 'terms',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initSharedTermsPayerTabView',
      },
      static: {
        tab: 'customer',
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedCommunicationListTabComponent,
      path: 'communications',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initSharedCommunicationsTabView',
      },
      static: {
        tab: 'customer',
        contactType: CONTACT_TYPE_CUSTOMER,
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedCustomFieldsTabComponent,
      path: 'customFields',
      static: {
        tab: 'customer',
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedPortalTabComponent,
      path: 'portal',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initInvitations',
      },
      static: {
        tab: 'customer',
        type: CONTACT_TYPE_CUSTOMER,
      },
    }),
    createContextRoute({
      component: ContactDetailsCustomerAdditionalDetailsTabComponent,
      path: 'additionalDetails',
    }),
  ];

  constructor(public model: ContactDetailsModel,
              public form: ContactDetailsCustomerFormState,
              public userContext: BuilderUserContext) {
  }

  get currentTab(): string {
    return <string>this.model.getSlaveTabFor('customer');
  }

  onTabChanged(name: string): void {
    this.model.goToSubTab(name);
  }
}
